import React from "react";
import * as R from "ramda";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import { useSelector } from "react-redux";

import CandidateTags from "../../../../components/CandidateTags/CandidateTags";

function CandidatesTagsModal({ visible, onClose, candidates = [] }) {
  const { t } = useTranslation();
  const { companyTags, opportunityId } = useSelector(state => ({
    companyTags: R.pathOr([], ["company", "tags"], state).sort(),
    opportunityId: R.path(["opportunity", "selected", "id"], state)
  }));

  const tags = R.reduce(
    (acc, e) => {
      const ts = R.pathOr([], ["tags", opportunityId], e);
      return R.isNil(acc) ? ts : R.intersection(acc, ts);
    },
    null,
    candidates
  );

  const updateCandidates = ({ addTags, removeTags }) =>
    R.forEach(c => {
      if (!c.tags) c.tags = {};
      const ts = c.tags[opportunityId] || [];
      c.tags[opportunityId] = R.concat(R.without(removeTags, ts), addTags);
    }, candidates);

  return (
    <Modal
      title={t("opportunity:process.candidateDetails.tags")}
      maskClosable={false}
      footer={null}
      onCancel={onClose}
      visible={visible}
      destroyOnClose={true}
    >
      <CandidateTags
        candidates={R.map(R.prop("id"), candidates)}
        opportunityId={opportunityId}
        selectedTags={tags}
        allTags={companyTags}
        showCancelButton={true}
        onCancel={onClose}
        onSave={updateCandidates}
      />
    </Modal>
  );
}

export default CandidatesTagsModal;
